/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-07 12:05:07
 * @LastEditTime: 2022-01-07 14:30:40
 * @LastEditors: zhao - 🍉
 * @Description: 对账报表 - 单商户的对账列表
 * @FilePath: /zhzj-admin/src/page/AccountingRecordReport/components/MerchantReportInfoListView.jsx
 */
import { Popover } from 'antd';
import React from 'react'
import { dicPayChannel, dicPayType, liuShuiMeiJu } from '../../../axios/dictionaries';
import TableHelper from "../../../components/TableHelper";
import TableNewlineView from "../../../components/TableNewlineView";
import { fetchPlatformReportMerchantList } from '../../../services/platformReport';
import { findDict, formatTime } from '../../../utils';
const MerchantReportInfoList = (props) => {
    const columns = [
        {title: '项目名称', dataIndex: 'projectName'},
        {title: '房号', dataIndex: 'roomNos' , width: 120},
        {title: '租客', dataIndex: '_customer', width: 120, render: (text, records) => {
            return <TableNewlineView>{[records.customerName, records.customerPhone]}</TableNewlineView>
        }},
        {title: '我方流水号/他方流水号', dataIndex: 'order', width: 240, render:(text, records) => {
            return <TableNewlineView >{[records.orderNo, records.orderNoThird]}</TableNewlineView>
        }},
        {title: '交易名称', dataIndex: 'feeName', width: 180},
        {title: '交易金额', dataIndex: 'amount', width: 80},
        {title: '交易流水id', dataIndex: 'tradeRecordId'},
        { title: '交易方式', dataIndex: 'payType', width: 140, render: (text) => {
            return findDict(dicPayType, text).title
        } },
        { title: '交易状态', dataIndex: 'status', width: 70, render: (text) => {
            const current = findDict(liuShuiMeiJu, text)
            return <span style={{color: current.color}}>{current.title}</span>
        } },
        { title: '交易渠道', dataIndex: 'payChannel', width: 140, render: (text) => {
            return findDict(dicPayChannel, text).title
        } },
        {title: '交易时间', dataIndex: 'tradeTime', width: 140, render: (text) => formatTime(text,'YYYY-MM-DD HH:mm')},
        { title: '分账规则', dataIndex: 'subAccountDesc', width: 100, render: (text) => {
            return (
                text &&
                <Popover content={<div style={{width:400}}>{text}</div>} trigger="click">
                    <a>查看</a>
                </Popover> 
            )
        }},
        {title: '平台商户分账金额', dataIndex: 'platformAmount', width: 120},
        {title: '子商户分账金额', dataIndex: 'subAmount', width: 120},
        {title: '优惠金额', dataIndex: 'discountAmount', width: 80},

    ]
    const parseRequestData = (data) => {
        return {...data, ...props.params}
    }
    return (
        <TableHelper scroll={{x: 2200}} columns={columns} parseRequestData={parseRequestData} request={fetchPlatformReportMerchantList} />
    )
}

export default MerchantReportInfoList


// WEBPACK FOOTER //
// ./src/page/AccountingRecordReport/components/MerchantReportInfoListView.jsx